import React from 'react';
import Box from '@mui/material/Box';

import styles from './Bouncies.style';

function Loader() {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.loader} />
    </Box>
  );
}

Loader.propTypes = {};
export default Loader;
